<template>
  <el-dialog
    v-el-drag-dialog
    :visible.sync="innerVisible"
    :title="$t('SeaExport.SOPReceiver')"
    width="980px"
    :close-on-click-modal="false"
    class="grid-view"
  >
    <div class="main-content">
      <div style="display: flex;margin-bottom: 3px">
        <el-button v-if="action===ActionEnum.LOOK" type="primary" no="1" @click="toAddReceiver">{{ $t('Partners.btnAdd') }}</el-button>
        <el-button v-else type="primary" no="2" @click="toCancel">{{ $t('CargoMsg.Cargo_Cancel') }}</el-button>
        <el-checkbox v-show="cBoxShow" v-model="cBoxSelected" style="align-self: center;margin-left: 10px" no="3">{{ $t('CargoMsg.Cargo_Confirmed') }}</el-checkbox>
        <el-button v-if="action===ActionEnum.LOOK" type="danger" no="4" style="margin-left: auto;" @click="toClearReceiver">{{ $t('queryJob.Clear') }}</el-button>
      </div>
      <div class="section grid-wrapper">
        <cargo-ag-grid
          config-module="130143"
          :grid-options="notifyExtGrid.gridOptions"
          :column-defs="notifyExtGrid.columnDefs"
          :row-data="contactList"
          :style="{height:action===ActionEnum.LOOK?'350px':'150px'}"
          @gridReady="params=>{notifyExtGrid.gridApi=params.api}"
        />
      </div>
      <div v-show="action!==ActionEnum.LOOK" style="display: flex;flex-direction: column">
        <div>
          <!--          <div style="color: red;line-height: 30px">{{ $t('Message.NoteDoesNotAffectPartner') }}</div>-->
          <div style="display: flex;flex-direction: row;align-items: center;padding-bottom: 10px;">
            <el-radio-group v-show="action===ActionEnum.ADD" v-model="addMode" no="4">
              <el-radio :label="0">{{ $t('Message.AddFromPartner') }}</el-radio>
              <el-radio :label="1">{{ $t('Message.AddManually') }}</el-radio>
            </el-radio-group>
            <el-checkbox v-show="action === ActionEnum.EDIT || addMode === 1" v-model="syncContact" style="margin-left: 15px;">{{ $t('Partners.syncContact') }}</el-checkbox>
          </div>
        </div>
        <div v-show="action===ActionEnum.ADD&&addMode===0" class="section grid-wrapper">
          <cargo-ag-grid
            config-module="130144"
            :grid-options="usageGrid.gridOptions"
            :column-defs="usageGrid.columnDefs"
            :row-data="usageGrid.rowData"
            style="height: 150px;"
            @gridReady="params=>{usageGrid.gridApi=params.api}"
          />
        </div>
        <el-form v-show="action===ActionEnum.EDIT||addMode===1" label-width="90px" label-position="left">
          <div class="el-form-item-wrapper">
            <el-form-item :label="$t('Tool.UserName')+'：'" required>
              <el-input v-model="form.contactPerson" style="width: 200px;" no="5" />
            </el-form-item>
            <el-form-item :label="$t('Partners.pushNode')+'：'">
              <el-dropdown placement="bottom-start" trigger="click" @visible-change="onPushNodeChange">
                <span class="el-dropdown-link">
                  <el-input :value="getPushNodeLabel(form.pushNode)" style="width: 200px;" no="6" />
                </span>
                <el-dropdown-menu slot="dropdown">
                  <cargo-ag-grid
                    :show-side-bar="false"
                    :grid-options="pushNodeTree.gridOptions"
                    :row-data="pushNodeTreeRowData"
                    style="width:350px;height:300px;padding-left:2px"
                    @gridReady="params=>{pushNodeTree.gridApi=params.api}"
                  />
                </el-dropdown-menu>
              </el-dropdown>
              <div style="display: inline-block; vertical-align: middle;">
                <div style="line-height: 30px;margin-left: 5px">
                  <i class="el-icon-warning orange" />
                  {{ $t('Message.emptySopNodeWarning') }}
                </div>
              </div>
            </el-form-item>
            <el-form-item :label="$t('Message.ReceivingMethod')">
              <el-select v-model="form.pushMode" style="width: 200px;" no="7">
                <el-option :label="$t('Viewer.email')" :value="0" />
                <el-option :label="$t('Partners.shortMessage')" :value="1" />
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('SeaExport.Email2')+'：'" :required="emailMode">
              <el-input v-model="form.email" style="width: 200px;" no="8" />
            </el-form-item>
            <el-form-item :label="$t('Message.CellPhoneNumber')" :required="phoneMode">
              <el-input v-model="form.mobile" style="width: 200px;" no="9" />
            </el-form-item>
            <el-form-item :label="$t('queryJob.route')">
              <cargo-advance-select
                :select-type="TYPE_NAMES.basic_data_Region"
                filterable
                :default-value="form.airline"
                style="width:200px;"
                no="10"
                @parentCallBack="p=>{form.airline=p.value}"
              />
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_RpaAccount')">
              <el-input v-model="form.rpaAccount" style="width: 200px;" no="rpaAccount" />
              <el-checkbox v-model="form.enableEnterpriseWechat" no="enableEnterpriseWechat" style="margin-left: 10px;">{{ $t('CargoMsg.Cargo_PushEnterpriseWechat') }}</el-checkbox>
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_WechatGroupName')">
              <el-input v-model="form.wechatGroupName" style="width: 200px;" no="wechatGroupName" />
              <div style="display: inline-block; vertical-align: middle;">
                <div style="line-height: 30px;margin-left: 5px">
                  <i class="el-icon-warning orange" />
                  {{ $t('CargoMsg.Cargo_EnterpriseWechatSopTip') }}
                </div>
              </div>
            </el-form-item>
          </div>
        </el-form>
      </div>
    </div>
    <span v-show="action!==ActionEnum.LOOK" slot="footer">
      <el-button type="primary" no="11" @click="confirmHandler">{{ $t('CargoMsg.Cargo_ConfirmR') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import ColumnUtils from '@/utils/ColumnUtils'
import { getObjectByCache, syncSpecificBasicData } from '@/utils/basicDataCache'
import { AutoIncrementNum, DocumentManage } from '@/utils/commonUtil'
import { SopPushConfig } from '@/class/model/sys/SopPushConfig'
import { SopEmailReceiver } from '@/class/model/booking/SopEmailReceiver'
import { getContactList } from '@/api/partner/contact'
import { sopTreeByLob } from '@/api/sysManage/baseConfig/businessManage'
import StrUtils from '@/utils/StrUtils'
import { isNumber, validEmail } from '@/utils/validate'
import { saveSopEmailReceiver } from '@/api/booking/sopEmailReceiver'
import { getLoading } from '@/utils/utilBaseElement'
import { basicCacheKeys } from '@/utils/cacheConfig'
import { Company } from '@/class/model/mdm/Company'
const ActionEnum = {
  LOOK: 'look',
  ADD: 'add',
  EDIT: 'edit',
  DELETE: 'delete'
}

export default {
  name: 'SopDialog',
  components: { cargoAdvanceSelect },
  props: {
    visible: { type: Boolean, required: true },
    cmpIdx: { type: Number, required: true },
    job: { type: Object, default: () => { return {} } },
    agent: { type: String, required: true },
    lob: { type: String, required: true },
    contactList: { type: Array, required: true }
  },
  data() {
    return {
      innerVisible: this.visible,
      TYPE_NAMES,
      ActionEnum,
      action: ActionEnum.LOOK,
      cBoxShow: false,
      cBoxSelected: false,
      syncContact: true,
      delUuidList: [],
      airline: '', // 航线
      notifyExtGrid: {
        gridOptions: {
          rowSelection: 'single',
          suppressCellSelection: true,
          context: {
            componentParent: this
          }
        },
        columnDefs: [
          {
            headerName: this.$t('Tool.UserName'),
            field: 'contactPerson',
            width: 100
          },
          {
            headerName: this.$t('CargoMsg.Cargo_PushEnterpriseWechat'),
            field: 'enableEnterpriseWechat',
            initialWidth: 120, width: 120,
            cellRenderer: (params) => {
              return ColumnUtils.yesOrNoFun(params.value)
            },
            cellStyle: { textAlign: 'center' }
          },
          {
            headerName: this.$t('Partners.pushNode'),
            field: 'pushNode',
            width: 100,
            cellRenderer: params => {
              return this.getRealPushNodeLabel(params.value)
            },
            tooltipValueGetter: params => {
              return this.getRealPushNodeLabel(params.value)
            }
          },
          {
            headerName: this.$t('Message.ReceivingMode'),
            field: 'pushMode',
            width: 100,
            cellRenderer: params => {
              if (typeof params.value === 'number') {
                if (params.value === 0) {
                  return this.$t('Viewer.email')
                } else {
                  return this.$t('Partners.shortMessage')
                }
              }
              return ''
            }
          },
          {
            headerName: this.$t('SeaExport.Email2'),
            field: 'email',
            width: 100
          },
          {
            headerName: this.$t('Message.CellPhoneNumber2'),
            field: 'mobile',
            width: 100
          },
          {
            headerName: this.$t('queryJob.route'),
            field: 'airline',
            width: 100,
            hide: true,
            valueFormatter: params => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Region, 'code', params.value, 'name')
            }
          },
          {
            headerName: this.$t('queryJob.DataSource'),
            field: '',
            width: 100,
            cellRenderer: params => {
              if (params.data.uuid) {
                return this.$t('Partners.parter')
              } else {
                return this.$t('Partners.currentJob')
              }
            },
            excelRenderer: (params) => {
              if (params.data.uuid) {
                return this.$t('Partners.parter')
              } else {
                return this.$t('Partners.currentJob')
              }
            }
          },
          {
            headerName: this.$t('CargoMsg.Cargo_Operation'),
            field: '',
            width: 100,
            cellRenderer: params => {
              const editMethodPath = this.documentManage.getPath('toEditReceiver')
              const delMethodPath = this.documentManage.getPath('toDelReceiver')
              return `<div onclick="${editMethodPath}(${params.data.seq})" style="display: inline-block;color:green;margin-right: 5px;cursor: pointer">${this.$t('SeaExport.Edit')}</div>
                    <div onclick="${delMethodPath}(${params.data.seq})" style="display: inline-block;color:red;margin-right: 5px;cursor: pointer">${this.$t('SeaExport.Delete')}</div>`
            }
          }
        ],
        gridApi: null
      },
      autoIncrementNum: new AutoIncrementNum(),
      pushNodeTree: {
        gridOptions: {
          rowSelection: 'multiple',
          groupDefaultExpanded: 0,
          suppressRowClickSelection: true,
          treeData: true,
          getDataPath: data => {
            return data.path.split(',')
          },
          autoGroupColumnDef: {
            headerName: this.$t('Partners.pushNode'),
            width: 320,
            suppressMenu: true,
            cellRendererParams: {
              suppressDoubleClickExpand: true,
              innerRenderer: params => {
                if (params.data.type === 4) {
                  const iconName = params.data.checked ? 'checkbox-checked' : 'checkbox-notChecked'
                  return `<svg class="svg-icon" aria-hidden="true" style="height:1.2em;width:1.2em;vertical-align:text-bottom;">
                            <use xlink:href="#icon-${iconName}"></use>
                          </svg>
                          &nbsp;${params.data.chineseName}`
                }
                return params.data.chineseName
              }
            },
            tooltipValueGetter: params => {
              if (params.value && params.value.length === 3) {
                return params.data.chineseName
              }
              return this.getRealPushNodeLabel(params.value)
            },
            onCellClicked: params => {
              if (params.data.type === 4) {
                params.data.checked = !params.data.checked
                params.api.refreshCells({ force: true })
              }
            }
          },
          columnDefs: [],
          context: {
            componentParent: this
          }
        },
        rowData: [],
        gridApi: null
      },
      sopTemplatePushNodeMap: {},
      sopTemplatePushNodeTreeMap: {},
      documentManage: new DocumentManage(),
      addMode: 0, // 新增模式：0 从合作伙伴添加，1手动添加
      usageGrid: {
        gridOptions: {
          rowSelection: 'single',
          suppressCellSelection: true,
          context: {
            componentParent: this
          }
        },
        columnDefs: [
          {
            headerName: '', width: 55, checkboxSelection: true,
            sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
            headerCheckboxSelection: true
          },
          {
            headerName: this.$t('Tool.UserName'),
            field: 'contactPerson',
            width: 100
          },
          {
            headerName: this.$t('SeaExport.Email2'),
            field: 'email',
            width: 100
          },
          {
            headerName: this.$t('Message.CellPhoneNumber2'),
            field: 'mobile',
            width: 100
          },
          {
            headerName: this.$t('queryJob.route'),
            field: 'airline',
            width: 100,
            hide: true,
            valueFormatter: params => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Region, 'code', params.value, 'name')
            }
          },
          {
            headerName: this.$t('Partners.pushNode'),
            field: 'pushNode',
            width: 100,
            cellRenderer: params => {
              return this.getPushNodeLabel(params.value)
            },
            tooltipValueGetter: params => {
              return this.getPushNodeLabel(params.value)
            }
          },
          {
            headerName: this.$t('Partners.pushMode'),
            field: 'pushMode',
            width: 100,
            cellRenderer: params => {
              if (typeof params.value === 'number') {
                if (params.value === 0) {
                  return this.$t('Viewer.email')
                } else {
                  return this.$t('Partners.shortMessage')
                }
              }
              return ''
            }
          }
        ],
        rowData: [],
        gridApi: null
      },
      form: {
        contactPerson: '',
        pushNode: '',
        pushMode: 0,
        email: '',
        mobile: '',
        airline: '',
        rpaAccount: '',
        wechatGroupName: '',
        enableEnterpriseWechat: false,
        contactUuid: '',
        uuid: ''
      },
      baseForm: {
        contactPerson: '',
        pushNode: '',
        pushMode: 0,
        email: '',
        mobile: '',
        airline: '',
        rpaAccount: '',
        wechatGroupName: '',
        enableEnterpriseWechat: false,
        contactUuid: '',
        uuid: ''
      },
      pushNodeTreeRowData: []
    }
  },
  computed: {
    emailMode() {
      return this.form.pushMode === 0
    },
    phoneMode() {
      return this.form.pushMode === 1
    }
  },
  watch: {
    visible(newVal) {
      this.innerVisible = newVal
      if (newVal) {
        this.init()
      }
    },
    innerVisible(newVal) {
      if (!newVal) {
        this.action = ActionEnum.LOOK
        switch (this.agent) {
          case 'customer':
            if (this.cBoxSelected !== this.job.ifPushSop) {
              this.job.ifPushSop = this.cBoxSelected
              this.$emit('updateJob')
            }
            break
          case 'DestinationAgent':
            if (this.cBoxSelected !== this.job.ifPushSopM) {
              this.job.ifPushSopM = this.cBoxSelected
              this.$emit('updateJob')
            }
            break
          case 'DesignationAgent':
            if (this.cBoxSelected !== this.job.ifPushSopZ) {
              this.job.ifPushSopZ = this.cBoxSelected
              this.$emit('updateJob')
            }
            break
          case 'PortOfLoadingAgent':
            if (this.cBoxSelected !== this.job.ifPushSopQ) {
              this.job.ifPushSopQ = this.cBoxSelected
              this.$emit('updateJob')
            }
            break
        }
      }
      this.$emit('update:visible', newVal)
    }
  },
  beforeMount() {
    this.documentManage.set('toEditReceiver', seq => {
      this.toEditReceiver(seq)
    })
    this.documentManage.set('toDelReceiver', seq => {
      this.toDelReceiver(seq)
    })
  },
  beforeDestroy() {
    this.documentManage.destory()
  },
  methods: {
    async init() {
      Object.assign(this.form, this.baseForm)
      for (const item of this.contactList) {
        item.seq = this.autoIncrementNum.getNextNum()
      }
      this.syncContact = true
      this.cBoxShow = false
      this.delUuidList = []
      await SopPushConfig.findByOfficeId(this.$store.getters.currentOfficeId).then(data => {
        const sop = data.sopPushConfig
        if (this.$checkPermission(['role_confirm_cBox']) && sop.ifSop) {
          this.cBoxShow = true
          this.changecBox()
        }
        this.ifAirline = sop.ifAirline
      })
      this.airline = ''
      let port = null
      if (this.job.lob === 'SE' && this.job.dischargingPortCode) {
        port = getObjectByCache(TYPE_NAMES.basic_data_Seaport, 'code', this.job.dischargingPortCode)
      } else if (this.job.lob === 'SI' && this.job.loadingPortCode) {
        port = getObjectByCache(TYPE_NAMES.basic_data_Seaport, 'code', this.job.loadingPortCode)
      } else if (this.job.lob === 'AE' && this.job.destinationPortCode) {
        port = getObjectByCache(TYPE_NAMES.basic_data_Airport, 'code', this.job.destinationPortCode)
      } else if (this.job.lob === 'AI' && this.job.loadingPortCode) {
        port = getObjectByCache(TYPE_NAMES.basic_data_Airport, 'code', this.job.loadingPortCode)
      }
      this.airline = port ? port.region : ''
      if (this.ifAirline && this.airline) {
        const filterContactList = this.contactList.filter(p => p.airline === this.airline)
        if (filterContactList.length > 0) {
          this.contactList.splice(0, this.contactList.length, ...filterContactList)
        }
      }
      if (!this.sopTemplatePushNodeMap.hasOwnProperty(this.job.lob)) {
        sopTreeByLob({ lob: this.job.lob }).then(res => {
          const data = res.data.filter(p => p.path.startsWith(this.lob))
          data.forEach(item => {
            item.checked = false
          })
          const pushNodeTreeRowData = data
          const pushNodeMap = new Map()
          for (const item of pushNodeTreeRowData) {
            if (item.type === 3) {
              pushNodeMap.set(item.uuid, item.chineseName)
            } else if (item.type === 4) {
              let parentName = pushNodeMap.get(item.parentUuid)
              parentName = parentName ? '(' + parentName + ')' : ''
              pushNodeMap.set(item.uuid, parentName + item.chineseName)
            }
          }
          this.sopTemplatePushNodeMap[this.job.lob] = pushNodeMap
          this.sopTemplatePushNodeTreeMap[this.job.lob] = pushNodeTreeRowData
          this.pushNodeTreeRowData = pushNodeTreeRowData
          // pushNodeMap还未赋值就被使用到了，所以此处需要重新渲染表格
          if (this.notifyExtGrid.gridApi) {
            this.notifyExtGrid.gridApi.refreshCells({ force: true })
          }
        })
      } else {
        this.pushNodeTreeRowData = this.sopTemplatePushNodeTreeMap[this.job.lob]
      }
      getContactList({ cmpIdx: this.cmpIdx, pageSize: 100000 }).then(res => {
        this.usageGrid.rowData = res.data.list
      })
    },
    getRealPushNodeLabel(val) {
      let label = ''
      if (val) {
        label = this.getPushNodeLabel(val) || this.$t('Message.NoSopNodeMatched')
      }
      return label
    },
    changecBox() {
      switch (this.agent) {
        case 'customer':
          this.cBoxSelected = this.job.ifPushSop
          break
        case 'DestinationAgent':
          this.cBoxSelected = this.job.ifPushSopM
          break
        case 'DesignationAgent':
          this.cBoxSelected = this.job.ifPushSopZ
          break
        case 'PortOfLoadingAgent':
          this.cBoxSelected = this.job.ifPushSopQ
          break
      }
    },
    getPushNodeLabel(value) {
      const pushNodeMap = this.sopTemplatePushNodeMap[this.job.lob]
      if (value && pushNodeMap) {
        const values = value.split(',')
        const result = Array.from(values, p => pushNodeMap.get(p))
          .filter(p => p)
          .join(',')
        return result
      } else {
        return ''
      }
    },
    onPushNodeChange(isShow) {
      if (!isShow) {
        const pushNodeTreeRowData = this.pushNodeTreeRowData
        const rows = pushNodeTreeRowData.filter(p => p.checked)
        if (rows.length > 0) {
          this.form.pushNode = Array.from(rows, p => p.uuid)
            .join(',')
        } else {
          this.form.pushNode = ''
        }
      }
    },
    toClearReceiver() {
      for (const contact of this.contactList) {
        if (contact.sopEmailReceiverUuid) {
          this.delUuidList.push(contact.sopEmailReceiverUuid)
        }
      }
      this.contactList.splice(0, this.contactList.length)
      this.saveHandler(ActionEnum.DELETE)
    },
    toAddReceiver() {
      this.action = ActionEnum.ADD
      this.addMode = 0
      // const newForm = {}
      // 重置表单
      // for (const key in this.form) {
      //   if (typeof this.form[key] === 'number') {
      //     newForm[key] = 0
      //   } else {
      //     newForm[key] = ''
      //   }
      // }
      for (const key in this.form) {
        if (typeof this.form[key] === 'number') {
          this.form[key] = 0
        } else {
          this.form[key] = ''
        }
      }
      Object.assign(this.form, this.baseForm)
      this.form.airline = this.airline
      this.form.seq = null
    },
    toEditReceiver(seq) {
      const contact = this.contactList.find(p => p.seq === seq)
      if (contact) {
        this.action = ActionEnum.EDIT
        Object.assign(this.form, contact)
      }
    },
    toDelReceiver(seq) {
      const contact = this.contactList.find(p => p.seq === seq)
      if (contact.sopEmailReceiverUuid) {
        this.delUuidList.push(contact.sopEmailReceiverUuid)
      }
      const index = this.contactList.findIndex(p => p.seq === seq)
      if (index > -1) {
        this.contactList.splice(index, 1)
      }
      this.saveHandler(ActionEnum.DELETE)
    },
    toCancel() {
      this.action = ActionEnum.LOOK
    },
    confirmHandler() {
      let action = ''
      let msg = ''
      if (this.action === ActionEnum.ADD) {
        action = ActionEnum.ADD
        if (this.addMode === 0) {
          const rows = this.usageGrid.gridApi.getSelectedRows()
          if (rows.length === 0) {
            this.action = ActionEnum.LOOK
            return
          }
          for (const item of rows) {
            item.seq = this.autoIncrementNum.getNextNum()
            msg = this.getFieldsCheckResult(item)
            if (msg) {
              break
            }
            this.contactList.push(item)
          }
          if (msg) {
            this.$message.warning(msg)
            return
          }
          this.checkPushEnterpriseWechat(rows)
          /* 移除被选中项 */
          const usageRowData = this.usageGrid.rowData
          const newRowData = usageRowData.filter(p => !rows.includes(p))
          usageRowData.splice(0, usageRowData.length)
          usageRowData.push(...newRowData)
        } else if (this.addMode === 1) {
          msg = this.getFieldsCheckResult(this.form)
          if (msg) {
            this.$message.warning(msg)
            return
          }
          this.checkPushEnterpriseWechat([this.form])
          this.form.syncContact = this.syncContact
          this.contactList.push({ seq: this.autoIncrementNum.getNextNum(), ...this.form })
        }
      } else if (this.action === ActionEnum.EDIT) {
        msg = this.getFieldsCheckResult(this.form)
        if (msg) {
          this.$message.warning(msg)
          return
        }
        this.checkPushEnterpriseWechat([this.form])
        action = ActionEnum.EDIT
        // if (!this.form.contactPerson) {
        //   this.$message.warning('姓名不能为空！')
        //   return
        // }
        // if (!this.form.pushNode) {
        //   this.$message.warning(this.$t('Message.PushNodeCannotBeEmpty'))
        //   return
        // }
        const contact = this.contactList.find(p => p.seq === this.form.seq)
        if (contact) {
          Object.assign(contact, this.form)
          contact.syncContact = this.syncContact
          this.notifyExtGrid.gridApi.refreshCells({ force: true })
        }
      }
      this.action = ActionEnum.LOOK
      this.saveHandler(action)
    },
    // 自动保存数据
    saveHandler(action) {
      const sopList = []
      for (const item of this.contactList) {
        sopList.push({
          name: item.contactPerson,
          pushNode: item.pushNode,
          receivingMode: item.pushMode,
          email: item.email,
          phone: item.mobile,
          airline: item.airline,
          rpaAccount: item.rpaAccount,
          wechatGroupName: item.wechatGroupName,
          enableEnterpriseWechat: item.enableEnterpriseWechat,
          contactUuid: item.uuid,
          syncContact: item.syncContact,
          uuid: item.sopEmailReceiverUuid ? item.sopEmailReceiverUuid : ''
        })
      }
      const data = {
        sopList: sopList,
        jobUuid: this.job.uuid,
        ifPush: this.cBoxSelected,
        cmpIdx: this.cmpIdx,
        agent: this.agent,
        addMode: this.addMode,
        action: action,
        delUuidList: this.delUuidList
      }
      const loading = getLoading()
      saveSopEmailReceiver(data).then(async res => {
        if (res.ok) {
          await this.reloadData()
        }
        loading.close()
      }).catch(() => {
        loading.close()
      }).finally(() => {
        loading.close()
      })
      this.delUuidList = []
    },
    getFieldsCheckResult(form) {
      // 基本格式校验
      if (StrUtils.isEmpty(form.contactPerson)) {
        return this.$t('Partners.contactNameCannotBlank')
      }
      if (form.pushMode === 0 && (StrUtils.isEmpty(form.email) || !validEmail(form.email))) {
        return this.$t('Partners.emailBlankOrFormatError')
      }
      if (form.pushMode === 1 && (StrUtils.isEmpty(form.mobile) || !isNumber(form.mobile))) {
        return this.$t('Partners.mobileBlankOrFormatError')
      }
      // 相同航线联系人信息校验
      const existContactList = [...this.contactList]
      const uuids = existContactList.map(item => item.uuid)
      // 过滤出在不在当前业务的合作伙伴联系人
      for (const item of this.usageGrid.rowData) {
        if (!uuids.includes(item.uuid)) {
          existContactList.push({ ...item })
        }
      }
      let sameAirline
      for (const contact of existContactList) {
        let ifSame = false
        ifSame = contact.contactPerson === form.contactPerson
        ifSame = ifSame && (contact.pushMode === form.pushMode)
        ifSame = ifSame && (contact.airline === form.airline)
        // 编辑时跳过当前编辑联系人校验
        // 有seq才判断，针对手动新增时 与当前业务未使用的合作伙伴联系人作比较，seq都没有值
        if (form.seq) {
          ifSame = ifSame && (contact.seq !== form.seq)
        }
        if (form.email) {
          ifSame = ifSame && (contact.email === form.email)
        }
        if (form.mobile) {
          ifSame = ifSame && (contact.mobile === form.mobile)
        }
        if (ifSame) {
          sameAirline = contact
          break
        }
      }
      if (sameAirline) {
        const modeStr = form.pushMode === 0 ? this.$t('Partners.mailMode') : this.$t('Partners.phoneMode')
        if (sameAirline.email && (sameAirline.email === form.email)) {
          return this.$t('Partners.sameAirlineInvalidMsg', [form.contactPerson, modeStr, this.$t('SeaExport.Email')])
        }
        if (sameAirline.mobile && (sameAirline.mobile === form.mobile)) {
          return this.$t('Partners.sameAirlineInvalidMsg', [form.contactPerson, modeStr, this.$t('Message.CellPhoneNumber2')])
        }
      }
      return ''
    },
    async reloadData() {
      await SopEmailReceiver.queryJobSopReceiver(this.job.uuid, this.cmpIdx, this.agent).then(data => {
        this.contactList.splice(0, this.contactList.length, ...data)
        for (const item of this.contactList) {
          item.seq = this.autoIncrementNum.getNextNum()
        }
        if (this.ifAirline && this.airline) {
          const filterContactList = this.contactList.filter(p => p.airline === this.airline)
          if (filterContactList.length > 0) {
            this.contactList.splice(0, this.contactList.length, ...filterContactList)
          }
        }
      })
      await getContactList({ cmpIdx: this.cmpIdx, pageSize: 100000 }).then(res => {
        this.usageGrid.rowData = res.data.list
      })
      await syncSpecificBasicData(basicCacheKeys.basic_data_Company)
      const company = await Company.getCompanyById(this.cmpIdx)
      Company.clearCache(company.uuid)
    },
    checkPushEnterpriseWechat(rows) {
      for (const item of rows) {
        if (item.enableEnterpriseWechat && (StrUtils.isEmpty(item.rpaAccount) || StrUtils.isEmpty(item.wechatGroupName))) {
          return this.$message.warning(this.$t('CargoMsg.Cargo_PushEnterpriseWechatTip'))
        }
      }
    }
  }
}
</script>
